import React from "react";
import "./Roadmap.css";
import img1 from "../../Assets/Pets/Druid.gif";
import img2 from "../../Assets/Pets/Dragon.gif";
function Roadmap() {
  return (
    <div id="roadmap" className="roadmap">
      <img src={img1} className="img1" alt="" />
      <img src={img2} className="img2" alt="" />
      <h1>ROADMAP</h1>
      <div className="roadmap_div">
        <div className="roadmap-top"> 
          <div className="milestone">
            <p className="small-width">DEMO RELEASED</p>
            <p className="margin-left">3000 Pets on sale for 0.111 ETH</p>
          </div>
          <p className="middle blue-text">EARLY ALPHA INVESTORS</p>
          <div className="milestone">
            <p>1000 SOLD</p>
            <p>2 ETH Giveaway for ten lucky holders</p>
          </div>
          <div className="milestone">
            <p>2000 SOLD</p>
            <p>3 ETH Giveaway held for twenty lucky holders</p>
          </div>
          <div className="milestone">
            <p>3000 SOLD</p>
            <p>3 Rare Dragon Giveaways</p>
          </div>
          <div className="milestone">
            <p className="giveway" style={{textAlign:"center"}}>Giveaway winners are posted on Mystical Pet's Social Media sites which are updated with a RNG roll video when the given milestones are reached So make sure you are Following our Social Media for the Latest Updates</p>
          </div>
          <div className="milestone">
          <p>&nbsp;</p>
          </div>
          <div className="title">
        <p className="middle nextmiddle" style={{textAlign:"center"}}>
        SINGLE PLAYER GAME RELEASED
        </p>
        </div>
          <div className="spacing">
          <p className="middle nextmiddle">
          <div className="title2">
          12,999 PETS FOR 7.77 ETH
          </div>
          <p>
          </p>
          <div className="title2">
          2.22 ETH will be rewarded to the holders that<br />hold the original 3000 pets once mint is complete
          </div>
          
          </p>
          <p className="middle nextmiddle">
          That's more than $23.3 Million given<br /> back to the investors that hold<br />the original 3000 tokens
          </p>

        </div>
        <div className="milestone">
          <p>&nbsp;</p>
          </div>
        </div>
        <div className="milestone">
          <p>10% SOLD</p>
          <p>5 ETH giveaway to 3 lucky holders</p>
        </div>
        <div className="milestone">
          <p>20% SOLD</p>
          <p>Lottery System is activated</p>
        </div>
        <div className="milestone">
          <p>30% SOLD</p>
          <p>Website Updated for Mystical Pets</p>
        </div>
        <div className="milestone">
          <p>40% SOLD</p>
          <p>5 ETH Giveaway held for 5 lucky holders</p>
        </div>
        <div className="milestone">
          <p>50% SOLD</p>
          <p>1000 ETH invested into the Community Wallet for Blue Chip NFTs</p>
        </div>
        <div className="milestone">
          <p>60% SOLD</p>
          <p>
            Profile JPEG mints for holders and 500 ETH added to the Lottery
            Vault, two more lucky holders are rewarded an ETH every month.
          </p>
        </div>
        <div className="milestone">
          <p>70% SOLD</p>
          <p>5 ETH giveaway to 25 lucky holders</p>
        </div>
        <div className="milestone">
          <p>80% SOLD</p>
          <p>
            Merch Store opens, 30% of the profits are distributed to holders
            every year
          </p>
        </div>
        <div className="milestone">
          <p>90% SOLD</p>
          <p>Music Studio registered to produce albums and music videos</p>
        </div>
        <div className="milestone">
          <p>100% SOLD</p>
          <p>
            Multiplayer 3D AAA Game on PC/Consoles, breeding, staking, and change
            color/species mechanism with ERC-20 Development starts
          </p>
        </div>
      </div>
    </div>
  );
}

export default Roadmap;
